import axiosClient from "apis/axios-client";

/**
 * Reward amounts for the signed-in user's referral program.
 * `referrerCredits` — tokens the user earns per friend who joins.
 * `refereeCredits`  — tokens the invited friend receives on joining.
 * The backend already resolves the correct amounts for this user (community
 * vs non-community), so the frontend just displays what it returns.
 */
export interface MyReferralReward {
  referrerCredits: number;
  refereeCredits: number;
  isCommunityMember: boolean;
}

/**
 * GET /api/Referrals/MyReferralReward
 *
 * Rejects with the AxiosError on failure. A 404 means the referral program is
 * not active — callers should handle that distinctly (see useReferralReward).
 */
export const getMyReferralReward = async (): Promise<MyReferralReward> => {
  const data = (await axiosClient.get<MyReferralReward>(
    "/Referrals/MyReferralReward",
  )) as unknown as MyReferralReward;
  return data;
};
